import { Box, ToggleButton, Typography } from '@mui/material';
import usePaymentProviders from '../../../../hooks/payment/usePaymentProviders';
import { PaymentTransactionType } from '../../../../types/enums';
import { PaymentProvider } from '../../../../types/payment';

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 1.5,
  },
  providerButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 1.5,
    backgroundColor: 'neutral.600',
    color: 'neutral.200',
    borderRadius: 2.5,
    border: '1px solid',
    borderColor: 'neutral.500',
    p: 1.5,
    textTransform: 'none',
    '&:hover': {
      borderColor: 'primary.main',
      backgroundColor: 'neutral.600',
    },
    '&.Mui-selected': {
      borderColor: 'primary.main',
      backgroundColor: 'neutral.600',
      '&:hover': {
        borderColor: 'primary.main',
        backgroundColor: 'neutral.600',
      },
    },
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  providerIcon: {
    fontSize: '2rem',
  },
  label: {
    typography: 'body3',
    fontWeight: 700,
    color: 'text.primary',
  },
} as const;

const NeobetPaymentProviders = ({
  transactionType,
  selectedProvider,
  onProviderChange,
  paymentProviders,
  paymentGateway,
}: {
  transactionType: PaymentTransactionType;
  selectedProvider: string | null;
  onProviderChange: (provider: string) => void;
  paymentProviders: PaymentProvider[];
  paymentGateway: string;
}) => {
  const providersByTransactionType = usePaymentProviders(paymentProviders, transactionType, paymentGateway);

  return (
    <Box sx={styles.grid}>
      {providersByTransactionType.map((provider) => {
        const IconComponent = provider.icon;

        return (
          <ToggleButton
            key={provider.value}
            value={provider.value}
            sx={styles.providerButton}
            onClick={() => onProviderChange(provider.value)}
            selected={selectedProvider === provider.value}
          >
            <Box sx={styles.iconBox}>
              <IconComponent sx={styles.providerIcon} />
            </Box>
            <Typography sx={styles.label}>{provider.label}</Typography>
          </ToggleButton>
        );
      })}
    </Box>
  );
};

export default NeobetPaymentProviders;
